/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NetConnectRssIcon16Light } from './NetConnectRssIcon16Light';
import { NetConnectRssIcon16Regular } from './NetConnectRssIcon16Regular';
import { NetConnectRssIcon16Solid } from './NetConnectRssIcon16Solid';
import { NetConnectRssIcon20Light } from './NetConnectRssIcon20Light';
import { NetConnectRssIcon20Regular } from './NetConnectRssIcon20Regular';
import { NetConnectRssIcon20Solid } from './NetConnectRssIcon20Solid';
import { NetConnectRssIcon24Regular } from './NetConnectRssIcon24Regular';
import { NetConnectRssIcon24Solid } from './NetConnectRssIcon24Solid';
import { NetConnectRssIcon32Regular } from './NetConnectRssIcon32Regular';
import { NetConnectRssIcon64Regular } from './NetConnectRssIcon64Regular';
var sizes = {
    16: {
        light: NetConnectRssIcon16Light,
        regular: NetConnectRssIcon16Regular,
        solid: NetConnectRssIcon16Solid,
    },
    20: {
        light: NetConnectRssIcon20Light,
        regular: NetConnectRssIcon20Regular,
        solid: NetConnectRssIcon20Solid,
    },
    24: {
        regular: NetConnectRssIcon24Regular,
        solid: NetConnectRssIcon24Solid,
    },
    32: {
        regular: NetConnectRssIcon32Regular,
    },
    64: {
        regular: NetConnectRssIcon64Regular,
    },
};
export var NetConnectRssIcon = forwardRef('NetConnectRssIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
